import request from '@/utils/request'
import trace from '@/utils/trace'
import Yfb from '../views/hlb/ysYfb/yfb.vue'
// 用户相关API
export const userApi = {
  // 入口统计
  prepare(data) {
    return request({
      url: '/am/api/am/command/v2/prepare',
      method: 'post',
      data
    })
  },
  //获取token
  generateToken(data) {
    return request({
      url: '/am/api/am/command/v2/generateToken',
      method: 'post',
      data
    })
  },
  //传手机给后端
  register(data) {
    return request({
      url: '/uaa/api/app/auth/register',
      method: 'post',
      data
    })
  },
  getchannel(params) {
    return request({
      url: '/base/api/channel/getChannelEncryptionInfo',
      method: 'get',
      params
    })
  },
  //拉起微信安卓引导页
  evokeBroswer(params) {
    return request({
      url: '/am/api/associateMember/command/evokeBroswer',
      method: 'get',
      params
    })
  },

  //下单
  signOrder(data) {
    return request({
      url: '/am/api/am/command/quickBindV3',
      method: 'post',
      data
    })
  },
    //合利宝下单
  signOrderHlb(data) {
    return request({
      url: '/am/api/am/command/quickBindByHLBV3',
      method: 'post',
      data
    })
  },
 
  //储存键值对
  saveFastAppUrl(data) {
    return request({
      url: '/base/api/fast/app/saveFastAppUrl',
      method: 'post',
      data
    })
  },
  //判断当前手机是否能走快应用（默认关闭）
  supportsFastApp(data) {
    return request({
      url: '/base/api/user/agent/supportsFastApp',
      method: 'post',
      data
    })
  },


  //判断当前手机是否能走快应用（默认开启）
  fcFast(data) {
    return request({
      url: '/base/api/user/agent/fengchaoSupportsFastApp',
      method: 'post',
      data
    })
  },
  //微信环境禁止分享
  getSignConfig(data) {
    return request({
      url: '/uaa/api/wechat/mp/getSignConfig',
      method: 'post',
      data
    })
  },
  //支付宝获取手机（生活号）
  authorizeMobile(data) {
    return request({
      url: '/uaa/api/alipay/life/user/authorizeMobile',
      method: 'post',
      data
    })
  },
  //流量统计
  statistics(data) {
    return request({
      url: '/am/api/sync/oldSystemData/syncFlowStatisticsData',
      method: 'post',
      data
    })
  },
  geturl(data) {
    return request({
      url: '/alternate/api/alternate/query/alternateProductInfo',
      method: 'post',
      data
    })
  },
  queryByCode(data) {
    return request({
      url: '/base/api/app/mapping/storage/queryByCode',
      method: 'post',
      data
    })
  },
  getAuditLink(data) {
    return request({
      url: '/base/api/productLinkConfig/getAuditLink',
      method: 'post',
      data
    })
  },
  //获取银行卡
 queryDictInfo(data) {
    return request({
      url: '/base/api/dict/queryDictInfo/BANK_TL',
      method: 'get',
      data
    })
  },

  //获取银行卡小悟合利宝
 queryDictInfoHlb(data) {
    return request({
      url: '/base/api/dict/queryDictInfo/BANK_HLB',
      method: 'get',
      data
    })
  },
  //获取银行卡宜搜合利宝
   queryDictInfoHlbYs(data) {
    return request({
      url: '/base/api/dict/queryDictInfo/BANK_HLB_YS',
      method: 'get',
      data
    })
  },
   //获取银行卡百川合利宝
   queryDictInfoHlbBc(data) {
    return request({
      url: '/base/api/dict/queryDictInfo/BANK_HLB_BAICHUAN',
      method: 'get',
      data
    })
  },
    //获取银行卡易付宝
    yfbGet(data) {
    return request({
      url: '/base/api/dict/queryDictInfo/BANK_YFB',
      method: 'get',
      data
    })
  },
  //易付宝下单
 
    Yfb(data) {
    return request({
      url: '/am/api/am/command/v3/yiFuBao',
      method: 'post',
      data
    })
  },
   //获取银行卡搜狐合利宝
   queryDictInfoHlbSh(data) {
    return request({
      url: '/base/api/dict/queryDictInfo/BANK_HLB_SH',
      method: 'get',
      data
    })
  },
   //小悟新绑卡下单
    quickBindByFYPayV3(data) {
    return request({
      url: '/am/api/am/command/quickBindByFYPayV3',
      method: 'post',
      data
    })
  },
  //小悟新绑卡获取银行卡
     queryxw(data) {
    return request({
      url: '/base/api/dict/queryDictInfo/BANK_FY_XWGS',
      method: 'get',
      data
    })
  },
  
 
  
 
  












}

export const traceApi = {
  // 入口埋点
  click(data) {
    return trace({
      url: '/api/trace/data/click/saveOrUpdate',
      method: 'post',
      data
    })
  },
  event(data) {
    return trace({
      url: '/api/trace/data/event/saveOrUpdate',
      method: 'post',
      data
    })
  },



}

// 导出所有API
export default {
  userApi,
  traceApi
}